import { Loader } from '@zeeve-platform/loader-component';
import loader from '../assets/spinner.svg';

interface props{
    showLoader: boolean
}
const LoaderOld = ({ showLoader }:props) => (
    <div>
        {showLoader && <Loader imagePath={loader} />}
    </div>
);
export default LoaderOld;